enum ClientId {
  DEALERSHIP = 'dealership',
  DEFAULT = 'default',
  DRIVE = 'drive',
  FINANCING = 'financing',
  GUIDE_TO_EV_UI = 'guide_to_ev_ui',
  HOME_UI = 'home_ui',
  NEW_CARS = 'new_cars',
  SHAQVANA = 'shaqvana',
  SHARE = 'share_your_carvana',
  SRP_UI = 'srp_ui',
  VDP_UI = 'vdp_ui',
  VM_UI = 'vending_machine_ui',
  WHAT_TO_EXPECT_UI = 'what_to_expect_ui'
}

export default ClientId;
